<template>
  <div>
    <ifac-page-size-select
      v-show="rowData.length > 0"
      v-model="pageSizeChoice"
      :allow-all="allowAll"
      @change="onPageSizeChanged"
    />
    <ag-grid-vue
      class="ag-theme-alpine"
      :pagination="true"
      :columnDefs="columnDefs"
      :defaultColDef="defaultColDef"
      :rowData="rowData"
      :gridOptions="gridOptions"
      :paginationPageSize="paginationPageSize"
      @gridReady="onGridReady"
      @cellClicked="onCellClicked"
      rowSelection="single"
      domLayout="autoHeight"
    ></ag-grid-vue>
  </div>
</template>

<script>
import { AgGridVue } from 'ag-grid-vue';
import Nominations from '@/services/Api/Awards/Nominations';
import GridMixin from '@/views/components/grids/GridMixin';
import {
  gridColumns,
  gridDefaultColDef,
} from '@/views/components/grids/awards/NominationsGrid';

export default {
  name: 'Conferences',
  components: {
    AgGridVue,
  },
  mixins: [GridMixin],
  data() {
    return {
      rowData: [],
      defaultColDef: gridDefaultColDef,
      columnDefs: gridColumns,
    };
  },
  methods: {
    postGridReady() {
      this.refresh();
    },
    async refresh() {
      this.refreshing = true;

      try {
        const params = {
          filter: 'mine',
        };
        const { data } = await Nominations.all(params);
        this.rowData = data.data;

        this.busy = false;
      } finally {
        this.refreshing = false;
      }
    },
    onCellClicked({ data }) {
      this.$router.push({
        name: 'NominationsEdit',
        params: {
          nomination: data.id,
        },
      });
    },
  },
};
</script>
